"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SchedulingInstructions = void 0;
const react_1 = __importDefault(require("react"));
const ProviderTabs_styles_1 = require("../../ProviderTabs.styles");
const RichTextArrayRenderer_1 = require("../../RichTextArrayRenderer");
const mapNotesFieldToTextContent_1 = require("../Notes/mapNotesFieldToTextContent");
const SchedulingInstructions = ({ labels: { missingValueLabel = 'None specified' } = {}, provider, onRichTextLinkClick }) => {
    const mappedContent = react_1.default.useMemo(() => {
        const notesFields = [
            {
                label: 'Scheduling Instructions',
                path: 'rmc_scheduling_instructions'
            }
        ];
        return notesFields.map((0, mapNotesFieldToTextContent_1.mapNotesFieldToTextContent)(provider, missingValueLabel));
    }, [missingValueLabel, provider]);
    return (react_1.default.createElement(ProviderTabs_styles_1.Content, { "data-testid": "scheduling_instructions" },
        react_1.default.createElement(RichTextArrayRenderer_1.RichTextArrayRenderer, { id: `notes-renderer-${provider.id}`, content: mappedContent, onRichTextLinkClick: onRichTextLinkClick })));
};
exports.SchedulingInstructions = SchedulingInstructions;
//# sourceMappingURL=SchedulingInstructions.js.map